// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const referenceOJKSliceService = {};

referenceOJKSliceService.referenceOJKList = function (data) {
  // console.log("🚀 ~referenceOJKSliceService data:", data);
  return lossClient({
    url: "/reference/rojkjabatan",
    method: "get",
    data: data,
  });
};

export default referenceOJKSliceService;
